export default __webpack_public_path__ + "static/media/admns-blding.9027bdb5.jpg";